import { BidderAddress } from './BidderAddresses';

export type GeoCoordinates = {
    latitude: number;
    longitude: number;
} | null;

type AcceptedTermsOfService = 'accepted' | 'unknown' | 'withdrawn';

export type BidderProfile = {
    acceptedTermsOfService: AcceptedTermsOfService;
    address: string;
    address2: string;
    addressId: number;
    addresses: BidderAddress[];
    approvalId: number;
    bidderId: number;
    city: string;
    country: string;
    countryCode: string;
    createdDate: string;
    creditCardValidated: boolean;
    email: string;
    firstName: string;
    hasEverRegisteredForAuction: boolean;
    lastName: string;
    latitude: string | null;
    levelOneScore: number;
    longitude: string | null;
    mobileCarrier: number;
    mobileNumber: string;
    phoneNumber: string;
    phoneNumber2: string;
    premiumBidder: boolean;
    profileComplete: boolean;
    resellerId: string;
    signupClient: string;
    signupClientVersion: string;
    standing: string;
    state: string;
    username: string;
    zip: string;
};

export type UserData = {
    ANMS: number;
    preferredCurrency: string;
    // premiumBidder is not used, used to be for ACH, but now it is unused - blake 2021-06-28
    upcomingBids?: number;
} & BidderProfile;

export const EmptyUserData: UserData = {
    acceptedTermsOfService: 'unknown',
    address: '',
    address2: '',
    addresses: [],
    addressId: 0,
    ANMS: 0,
    approvalId: 0,
    bidderId: -1,
    city: '',
    country: '',
    countryCode: '',
    createdDate: '',
    creditCardValidated: false,
    email: '',
    firstName: '',
    hasEverRegisteredForAuction: false,
    lastName: '',
    latitude: null,
    levelOneScore: 0,
    longitude: null,
    mobileCarrier: 0,
    mobileNumber: '',
    phoneNumber: '',
    phoneNumber2: '',
    preferredCurrency: 'USD',
    premiumBidder: false,
    profileComplete: false,
    resellerId: '',
    signupClient: '',
    signupClientVersion: '',
    standing: '',
    state: '',
    upcomingBids: 0,
    username: '',
    zip: '',
};
